
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/fansi-video",
      function () {
        return require("private-next-pages/help/fansi-video.tsx");
      }
    ]);
  